import { Client } from '@web/api';
import {
  SilosDocument,
  SilosQuery,
  SilosQueryVariables,
} from '@/pages/FarmerPages/FarmerRetailerPages/CheckoutPage/Components/Silos.generated';

export const verifySiloExists = async (
  siloID: string | null | undefined,
  client: Client,
): Promise<boolean> => {
  if (!siloID) return true;

  const { data } = await client.query<SilosQuery, SilosQueryVariables>(
    SilosDocument,
    {},
    {
      requestPolicy: 'network-only',
    },
  );

  const fetchedSilos = data?.currentUser?.silos ?? [];

  const siloExists = siloID
    ? fetchedSilos.some((silo) => silo.id === siloID)
    : true;

  return siloExists;
};
